import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ProblemSection from "@/components/landing/ProblemSection";
import ProcessFlow from "@/components/landing/ProcessFlow";
import FeatureCards from "@/components/landing/FeatureCards";
import WorkspaceIntegration from "@/components/landing/WorkspaceIntegration";
import FAQSection from "@/components/landing/FAQSection";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import { BookingProvider } from "@/context/BookingContext";

export default function LandingPage() {
  return (
    <BookingProvider>
      <main
        data-testid="landing-page"
        className="min-h-screen bg-white text-[#0B1F3A] selection:bg-[#3B82F6] selection:text-white"
      >
        <Navbar />
        <Hero />
        <ProblemSection />
        <ProcessFlow />
        <FeatureCards />
        <WorkspaceIntegration />
        <FAQSection />
        <FinalCTA />
        <Footer />
      </main>
    </BookingProvider>
  );
}
